// extracted by mini-css-extract-plugin
module.exports = {"manage":"manage__modules-recruitment-browser-_page-Manage"};